import React, { CSSProperties } from 'react';
import { useTheme } from '@/contexts/theme-context';

export const ConicalGradient: React.FC = () => {
  const theme = useTheme();
  return (
    <div
      style={{
        ...style,
        background: `conic-gradient(from 270deg, transparent 25%, ${theme.colors.accent})`,
      }}
    />
  );
};

const style: CSSProperties = {
  height: '100%',
  width: '100%',
};
